export function toggleDescription() {
    if (!document.getElementById('descriptionTitle'))
        return;
    if (!document.getElementById('descriptionTitleMobile'))
        return;

    let button = document.getElementById('descriptionTitle');
    let buttonMobile = document.getElementById('descriptionTitleMobile');

    let clickFlag = false;

    button.addEventListener('click', function (event) {
        if (!clickFlag) {
            var clickedButton = this;
            var accordionContent = document.getElementById('descriptionText');
            clickFlag = true;
            accordionContent.classList.toggle('closed');
            clickedButton.classList.toggle('closed');

            setTimeout(() => {
                clickFlag = false;
            }, 300);
        }
    });
    buttonMobile.addEventListener('click', function (event) {
        if (!clickFlag) {
            var clickedButton = this;
            var accordionContent = document.getElementById('descriptionTextMobile');
            clickFlag = true;
            accordionContent.classList.toggle('closed');
            clickedButton.classList.toggle('closed');

            setTimeout(() => {
                clickFlag = false;
            }, 300);
        }
    });
}